<div class="main-content">
  <div class="container-fluid">
    <div class="row" *ngIf="insight">

      <div class="row">
        <div class="col-md-12">
          <button mat-raised-button class="btn btn-default btn-round btn-link"
                  [routerLink]="['/observability/seo/keywordInsights']">
            <i class="material-icons">arrow_back</i> Back to List
          </button>
        </div>
      </div>
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-info">
            <div class="row">
              <div class="col-md-10">
                <h4 class="card-title">Keyword Insight Detail</h4>
                <p class="card-category">{{ insight.url }}</p>
              </div>
              <!-- <div class="col-md-2 text-right">
                <button mat-raised-button class="btn btn-white btn-round btn-just-icon"
                        [routerLink]="['/observability/seo/keywordInsights']" matTooltip="Back to list">
                  <i class="material-icons">arrow_back</i>
                  <div class="ripple-container"></div>
                </button>
              </div> -->
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <div class="info-area">
                  <div class="icon icon-info">
                    <i class="material-icons">key</i>
                  </div>
                  <h4 class="info-title">Primary Keyword</h4>
                  <p>{{ insight.primaryKeyword || insight.currentKeyword }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="info-area">
                  <div class="icon icon-success">
                    <i class="material-icons">category</i>
                  </div>
                  <h4 class="info-title">Type</h4>
                  <p>{{ insight.type | titlecase }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="info-area">
                  <div class="icon icon-warning">
                    <i class="material-icons">psychology</i>
                  </div>
                  <h4 class="info-title">Search Intent</h4>
                  <p>{{ insight.searchIntent | uppercase }}</p>
                </div>
              </div>
            </div>

            <hr>

            <div class="row">
              <div class="col-md-6">
                <h4>Secondary Keywords</h4>
                <div class="stats-tags">
                  <span *ngFor="let kw of insight.secondaryKeywords" class="badge badge-primary mr-1 mb-1">{{ kw }}</span>
                  <span *ngIf="!insight.secondaryKeywords?.length" class="text-muted">None identified</span>
                </div>

                <h4 class="mt-4">Long Tail Keywords</h4>
                <div class="stats-tags">
                  <span *ngFor="let kw of insight.longTailKeywords" class="badge badge-info mr-1 mb-1">{{ kw }}</span>
                  <span *ngIf="!insight.longTailKeywords?.length" class="text-muted">None identified</span>
                </div>

                <h4 class="mt-4">Semantic Keywords</h4>
                <div class="stats-tags">
                  <span *ngFor="let kw of insight.semanticKeywords" class="badge badge-success mr-1 mb-1">{{ kw }}</span>
                  <span *ngIf="!insight.semanticKeywords?.length" class="text-muted">None identified</span>
                </div>
              </div>

              <div class="col-md-6">
                <h4>Keyword Variations</h4>
                <div class="stats-tags">
                  <span *ngFor="let kw of insight.keywordVariations" class="badge badge-default mr-1 mb-1">{{ kw }}</span>
                  <span *ngIf="!insight.keywordVariations?.length" class="text-muted">None identified</span>
                </div>

                <h4 class="mt-4">Content Angles</h4>
                <ul class="list-group list-group-flush">
                  <li *ngFor="let angle of insight.contentAngles" class="list-group-item">
                    <i class="material-icons text-info mr-2">create</i> {{ angle }}
                  </li>
                  <li *ngIf="!insight.contentAngles?.length" class="list-group-item text-muted">No content angles suggested</li>
                </ul>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-md-12">
                <h4>Opportunities</h4>
                <div class="table-responsive">
                  <table mat-table [dataSource]="insight.opportunities" class="table">
                    <ng-container matColumnDef="keyword">
                      <th mat-header-cell *matHeaderCellDef>Keyword</th>
                      <td mat-cell *matCellDef="let element">{{ element.keyword }}</td>
                    </ng-container>
                    <ng-container matColumnDef="reason">
                      <th mat-header-cell *matHeaderCellDef>Reason</th>
                      <td mat-cell *matCellDef="let element">{{ element.reason }}</td>
                    </ng-container>
                    <ng-container matColumnDef="priority">
                      <th mat-header-cell *matHeaderCellDef>Priority</th>
                      <td mat-cell *matCellDef="let element">
                        <span class="badge" [ngClass]="{
                          'badge-danger': element.priority === 'high',
                          'badge-warning': element.priority === 'medium',
                          'badge-info': element.priority === 'low'
                        }">{{ element.priority | uppercase }}</span>
                      </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="opportunityColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: opportunityColumns;"></tr>
                  </table>
                  <div *ngIf="!insight.opportunities?.length" class="text-center p-3 text-muted">
                    No active opportunities found
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-md-12">
                <h4>Recommended Actions</h4>
                <ul class="list-group">
                  <li *ngFor="let action of insight.recommendedActions" class="list-group-item d-flex align-items-center">
                    <i class="material-icons text-success mr-3">check_circle</i>
                    {{ action }}
                  </li>
                  <li *ngIf="!insight.recommendedActions?.length" class="list-group-item text-muted">No recommended actions</li>
                </ul>
              </div>
            </div>

            <div class="row mt-4" *ngIf="insight.notes">
              <div class="col-md-12">
                <h4>Notes</h4>
                <div class="alert alert-light border">
                  {{ insight.notes }}
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="stats">
              <i class="material-icons">access_time</i> Last updated {{ insight.updatedAt | date:'medium' }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="loading" class="text-center">
      <mat-spinner diameter="50" style="margin: 50px auto;"></mat-spinner>
    </div>

    <div *ngIf="!loading && !insight" class="text-center">
       <div class="alert alert-warning">
         Keyword insight not found.
       </div>
    </div>
  </div>
</div>
